import { render, staticRenderFns } from "./ButtonBlock.vue?vue&type=template&id=4b3e48c4&"
import script from "./ButtonBlock.vue?vue&type=script&lang=js&"
export * from "./ButtonBlock.vue?vue&type=script&lang=js&"
import style0 from "./ButtonBlock.vue?vue&type=style&index=0&id=4b3e48c4&prod&lang=scss&"
import style1 from "./ButtonBlock.vue?vue&type=style&index=1&id=4b3e48c4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports